import apiReminderBuilder from "../../../api";

const extract = (res) => (res.status === "fulfilled" ? res.value?.data?.data || [] : []);

// Pickers of the template editor (and the list filter): active channels with their template_schema, and triggers.
export const loadTemplateDependencies = async () => {
  const [channelsRes, triggersRes] = await Promise.allSettled([apiReminderBuilder.getChannelOptions(), apiReminderBuilder.getTriggerOptions()]);
  return { channels: extract(channelsRes), triggers: extract(triggersRes) };
};
